<script>
import IndividualNumberField from '@phoenix/mixins/components/form/fields/IndividualNumberField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [IndividualNumberField],

  setup(props) {
    return useField(props, {
      rules: {
        regex: /(^[0-9]{1,3}\/[0-9A-Z]{2,5}RD[0-9A-Z]{1,4}$)|(^[0-9A-Z]{6}$)|(^[A-Z][0-9]{3}[A-Z]{3}$)/,
      },
    });
  },
};
</script>

<template>
  <div>
    <text-field ref="fieldRef" v-model="value" :attrs="field" :should-validate="false" />

    <div class="bg-gray-100 border-l-4 border-gray-200 mt-5 p-5">
      <p class="mb-2">{{ $t('Form.individualNumber.helper.text1') }}</p>

      <p class="mb-2">{{ $t('Form.individualNumber.helper.text2') }}</p>
      <ul class="mb-2">
        <li
          v-for="sample in helperSamples"
          :key="sample.number"
          v-html="$t('Form.individualNumber.helper.sample', sample)"
        />
      </ul>

      <p class="mb-4">{{ $t('Form.individualNumber.helper.text3') }}</p>
      <div class="sgphx">
        <a :href="locateYourBoutiqueLink" class="sgphx-btn sgphx-btn--underline">
          <span class="sgphx-btn__text">
            <span>{{ $t('Form.individualNumber.helper.link') }}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>
